var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"section"},[_c('div',{staticClass:"container"},[_c('content-placeholders',[_c('content-placeholders-heading'),_c('content-placeholders-heading',{attrs:{"img":false}})],1)],1)])}
var staticRenderFns = []

export { render, staticRenderFns }